import { configureRequest } from '../../../../networkRequests/apiClient/apiClient.functions'
import { getUserRoleForBackend } from '../../../../shared/functions/UserRole/userRoleManagment.functions'
import { ConfirmPickupRequest, ConfirmPickupSuccessResponse } from './confirmPickup.types'

export const confirmPickupApi = async (request: ConfirmPickupRequest): Promise<ConfirmPickupSuccessResponse> => {
  const response = await configureRequest({
    url: `logistics-partner/orders/${request.orderId}/confirm-pickup`,
    method: 'POST',
    data: {
      pickupCode: request.pickupCode,
      travelerId: request.travelerId,
      location: request.location,
      notes: request.notes || null
    },
    headers: {
      'X-User-Role': getUserRoleForBackend()
    }
  })

  return response as ConfirmPickupSuccessResponse
}
